<greco-alert *ngIf="alert$ | async as alert" style="display: block; margin-bottom: 8px" [config]="alert"></greco-alert>
